export default "__VITE_ASSET__3927db73__"